"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { CopyToClipboard, FlexColumn, formatAddress, Separator, SideSheetBody, SideSheetHeader, SideSheetHeaderTitle, TextBody, TextDisplay, UnstyledButton } from "@opensea/ui-kit";
import { ExpandMore } from "@opensea/ui-kit/icons";
import { QRCodeSVG } from "qrcode.react";
import { useTranslations } from "use-intl";
import { Button } from "../../../components/Button";
import { useAccount } from "../../../polychain/hooks";
export const DepositFlowContent = t0 => {
  const $ = _c(41);
  const {
    onBack
  } = t0;
  const t = useTranslations("wallet.DepositFlowContent");
  const {
    address: connectedAddress,
    chainArch
  } = useAccount();
  if (!connectedAddress) {
    return null;
  }
  let t1;
  if ($[0] !== chainArch || $[1] !== t) {
    t1 = chainArch === "SVM" ? t("receivingNote.svm") : t("receivingNote.evm");
    $[0] = chainArch;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const networkMessage = t1;
  let t2;
  if ($[3] !== onBack || $[4] !== t) {
    t2 = onBack && <UnstyledButton onClick={onBack}><ExpandMore className="rotate-90" size={24} title={t("back")} /></UnstyledButton>;
    $[3] = onBack;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("deposit");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <SideSheetHeaderTitle>{t3}</SideSheetHeaderTitle>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <SideSheetHeader className="gap-4">{t2}{t4}</SideSheetHeader>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Separator />;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("scanOrCopy");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <TextDisplay className="p-2 text-center" size="sm">{t7}</TextDisplay>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== connectedAddress) {
    t9 = connectedAddress && <FlexColumn className="items-center gap-6"><QRCodeSVG className="rounded-md border border-border-1 bg-white" includeMargin={true} level="H" size={200} value={connectedAddress} /><FlexColumn className="items-center gap-2"><WalletName address={connectedAddress} /></FlexColumn></FlexColumn>;
    $[18] = connectedAddress;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <FlexColumn>{t9}</FlexColumn>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("copyWalletAddress");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = <Button className="w-full bg-black text-white" variant="secondary">{t11}</Button>;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== connectedAddress || $[27] !== t12) {
    t13 = <CopyToClipboard text={connectedAddress}>{t12}</CopyToClipboard>;
    $[26] = connectedAddress;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== networkMessage) {
    t14 = <TextBody className="text-center" color="text-secondary" size="sm">{networkMessage}</TextBody>;
    $[29] = networkMessage;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = <FlexColumn className="w-full gap-4">{t13}{t14}</FlexColumn>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t10 || $[35] !== t15 || $[36] !== t8) {
    t16 = <SideSheetBody className="flex grow flex-col items-center justify-center"><FlexColumn className="items-center justify-between p-6"><FlexColumn className="items-center gap-10">{t8}{t10}{t15}</FlexColumn></FlexColumn></SideSheetBody>;
    $[34] = t10;
    $[35] = t15;
    $[36] = t8;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t16 || $[39] !== t5) {
    t17 = <>{t5}{t6}{t16}</>;
    $[38] = t16;
    $[39] = t5;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  return t17;
};
const query = graphql(`
  query DepositFlowContentQuery($identifier: String!) {
    profileByIdentifier(identifier: $identifier) {
      __typename
      ... on Profile {
        ensName
      }
    }
  }
`);
const CONTEXT = {
  suspense: false
};
function WalletName(t0) {
  const $ = _c(20);
  const {
    address
  } = t0;
  const t = useTranslations("wallet.DepositFlowContent");
  let t1;
  if ($[0] !== address) {
    t1 = {
      query,
      variables: {
        identifier: address
      },
      context: CONTEXT
    };
    $[0] = address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [t2] = useQuery(t1);
  const {
    data
  } = t2;
  const ensName = data?.profileByIdentifier?.__typename === "Profile" && data.profileByIdentifier.ensName ? data.profileByIdentifier.ensName : undefined;
  let t3;
  if ($[2] !== address || $[3] !== ensName) {
    t3 = ensName || formatAddress(address);
    $[2] = address;
    $[3] = ensName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== address || $[6] !== ensName) {
    t4 = ensName || formatAddress(address);
    $[5] = address;
    $[6] = ensName;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <TextDisplay className="font-mono" size="sm">{t4}</TextDisplay>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <CopyToClipboard text={t3}>{t5}</CopyToClipboard>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== address || $[14] !== ensName || $[15] !== t) {
    t7 = ensName && <CopyToClipboard text={address} tooltipText={t("copyAddress")}><TextBody className="font-mono" color="text-secondary" size="md">{formatAddress(address)}</TextBody></CopyToClipboard>;
    $[13] = address;
    $[14] = ensName;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}